import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=67e0fda7&scoped=true"
import script from "./OrderHeader.vue?vue&type=script&lang=js"
export * from "./OrderHeader.vue?vue&type=script&lang=js"
import style0 from "./OrderHeader.vue?vue&type=style&index=0&id=67e0fda7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e0fda7",
  null
  
)

export default component.exports